export default __webpack_public_path__ + "static/media/loader.61d9b192.svg";